import { render } from "./hkcmaPage.vue?vue&type=template&id=104d17dc&scoped=true&ts=true"
import script from "./hkcmaPage.vue?vue&type=script&lang=ts"
export * from "./hkcmaPage.vue?vue&type=script&lang=ts"

import "./hkcmaPage.vue?vue&type=style&index=0&id=104d17dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104d17dc"]])

export default __exports__